import React from 'react'

import { CheckboxMenu, SurfaceContainer } from '@caudena/core/ui-kit'
import { InputDropdown } from '@caudena/core/ui-kit'
import capitalizeFirstLetter from '@caudena/core/utils/capitalizeFirstLetter'

import { FieldProps } from './types'

const options = [
  {
    label: 'Entity',
    value: 'entity' as const,
  },
  {
    label: 'Category',
    value: 'category' as const,
  },
  {
    label: 'Exposure',
    value: 'exposure' as const,
  },
  {
    label: 'Fallback',
    value: 'score' as const,
  },
]

const Type = ({ value, onChange }: FieldProps<Array<string>>) => {
  const handleInputClear = () => {
    onChange([])
  }

  const handleChange = (selected) => {
    onChange(selected.length ? selected : [])
  }

  const printValue =
    (value?.length ?? 0) > 0 && (value?.length ?? 0) < 4
      ? value?.map(capitalizeFirstLetter).join(' / ')
      : ''

  return (
    <InputDropdown
      clearable
      sameWidth
      padded={false}
      variant="outline"
      startAddon={{ label: 'Rule type:' }}
      placeholder="All"
      value={printValue}
      onClear={handleInputClear}
    >
      <SurfaceContainer spaces={'md'}>
        <CheckboxMenu options={options} value={value} onChange={handleChange} />
      </SurfaceContainer>
    </InputDropdown>
  )
}

export default Type
